var exports = {
  "k": "xa9f3555f--df8b25--container",
  "X": "xa9f3555f--df8b25--container_mobile",
};

module.exports = exports;
